import { render, staticRenderFns } from "./UsersubTable.vue?vue&type=template&id=12b09b2a&scoped=true&"
import script from "./UsersubTable.vue?vue&type=script&lang=js&"
export * from "./UsersubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b09b2a",
  null
  
)

export default component.exports